import Vue from "vue";
import Vuex from "vuex";
import vuetify from "@/plugins/vuetify";

import axios from "axios";

import entities from "./entities";
import notifications from "./notifications";
import tenants from "./tenants";
import survey from "./survey";

import localStorageService from "../services/localStorageService";

Vue.use(Vuex);

const baseUser = () => {
  return {
    id: null,
    firstName: null,
    lastName: null,
    role: null,
    tenantClaims: []
  };
};

export default new Vuex.Store({
  modules: {
    entities,
    notifications,
    survey,
    tenants
  },
  state: {
    preferencesDrawer: false,
    theme: "adi",
    tenantId: null,
    user: baseUser()
  },
  getters: {
    authorized(state) {
      return ![null, undefined].some(x => x === state.user.id);
    }
  },
  mutations: {
    setTheme(state, theme) {
      Vue.set(state, "theme", theme);
      vuetify.framework.theme.themes.dark =
        vuetify.userPreset.theme.themes[theme];
      vuetify.framework.theme.themes.light =
        vuetify.userPreset.theme.themes[theme];
    },
    setTenantId(state, id) {
      state.tenantId = id;
    },
    setUser(state, user) {
      state.user.id = user.id;
      state.user.firstName = user.firstName;
      state.user.lastName = user.lastName;
      state.user.role = user.role;
      state.user.tenantClaims = user.tenantClaims;
    }
  },
  actions: {
    login({ commit, state }, { email, password }) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/auth", { email, password, tenantId: state.tenantId })
          .then(function(response) {
            localStorageService.setToken(response);
            commit("setUser", response);
            resolve(response);
          })
          .catch(reject);
      });
    },
    logout({ commit }) {
      commit("setUser", baseUser());
      localStorageService.clearToken();
    },
    refreshAuth({ state, commit }) {
      return new Promise((resolve, reject) => {
        let token = localStorageService.getRefreshToken();

        if (token) {
          axios
            .post("/api/auth/refresh-token", { token, tenantId: state.tenantId })
            .then(
              response => {
                localStorageService.setToken(response);
                commit("setUser", response);
                resolve();
              },
              () => {
                localStorageService.clearToken();
                reject();
              }
            )
            .catch(reject);
        } else {
          localStorageService.clearToken();
          reject();
          return;
        }
      });
    },
    setTenant({ commit, dispatch }, id) {
      commit('setTenantId', id);
      return dispatch('tenants/load', id);
    }
  }
});
